/* eslint-disable jsdoc/require-property-description */
import angular from 'angular';
import {
	ACCOUNT_REQUEST_STATUS_KID,
	COMPOSED_OF,
	STATUS_DONE,
	STATUS_READY,
	STATUS_TODO,
	STATUS_WAITING,
} from '~/scripts/constants/common-kids';
import { FileDownloadServiceModel } from '~/components/download/download.service';
import APIV5 from '~/models/api';
import { UserModel } from '~/scripts/services/model/user';
import $ from 'jquery';
// @ts-ignore
import Utils from '~/scripts/services/utils';
import {
	K_NODE_DATE_DEMANDE,
	K_NODE_BOOL,
	K_NODE_NOTIFY,
	K_NODE_SUPERADMIN,
	K_NODE_LOGIN_PASSWORD_CHANGE,
} from './new/new.controller';
import './users.scss';

/* globals Knitiv */

/**
 * @typedef Header
 * @property {string} text
 * @property {import('@knitiv/api-client-javascript').KNode} kid
 * @property {import('@knitiv/api-client-javascript').LinkerKNode} [linker_kid=0]
 * @property {boolean} [isSortable]
 * @property {string} [rowId]
 */

/**
 * @typedef Action
 * @property {string} id
 * @property {string} icon
 * @property {string} tooltip
 * @property {function(any): any} condition
 * @property {function(any, Event): any} callback
 */

/**
 * @typedef Status
 * @property {string} name
 * @property {string} color
 * @property {number} count
 * @property {string} kid
 * @property {boolean} checked
 * @property {boolean} show
 */

export const K_NODE_ACCOUNT_REQUEST = 'K_NODE;ACCOUNT_REQUEST';

const defaultFrom = {
	node: K_NODE_ACCOUNT_REQUEST,
	name: 'Gestion compte utilisateur',
	type: 'K_NODE;STRING',
};

const minimalQuery = {
	select: [
		{
			kid:               K_NODE_ACCOUNT_REQUEST,
			node:              'REPRE',
			op:                'count',
			repre:             'REPRE',
			inherits_extended: -1,
		},
	],
	from:   [defaultFrom],
	where:  {},
};

export default class UsersController {
	/* @ngInject */
	/**
	 * @param {import('angular').ILocationService} $location service
	 * @param {import('angular').IQService} $q service
	 * @param {import('angular').IScope} $scope service
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {import('angular').IWindowService} $window
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {FileDownloadServiceModel} FileDownloadService
	 * @param {import('~/scripts/services/model/node-service').NodeService} NodeService
	 * @param {any} Notification
	 * @param {UserModel} User
	 * @param {import('~/services/websocket.service').default} WebsocketService
	 */
	constructor(
		$location,
		$q,
		$scope,
		$timeout,
		$translate,
		$uibModal,
		$window,
		$rootScope,
		FileDownloadService,
		NodeService,
		Notification,
		User,
		WebsocketService,
	) {
		this.$location = $location;
		this.$q = $q;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.$window = $window;
		this.$rootScope = $rootScope;
		this.FileDownloadService = FileDownloadService;
		this.NodeService = NodeService;
		this.Notification = Notification;
		this.User = User;

		/** @type {number} */
		this.currentPage = 1;

		/** @type {'K_NODE;EMAIL_SEND_NO' | 'K_NODE;EMAIL_SEND_YES'} */
		this.emailNotify = 'K_NODE;EMAIL_SEND_NO';

		this.excelModel = `${this.User.getConfig().BACK?.url}/public/doc/account_import.xltx`;

		/** @type {Header[]} */
		this.headers = [
			{
				text: 'Civilité',
				kid:  'K_NODE;CIVILITY',
			},
			{
				text: 'Prénom',
				kid:  'K_NODE;FIRSTNAME',
			},
			{
				text: 'Nom de famille',
				kid:  'K_NODE;LASTNAME',
			},
			{
				text: 'Email',
				kid:  'K_NODE;EMAIL',
			},
			{
				text: 'Nom d\'utilisateur',
				kid:  'K_NODE;USERNAME',
			},
			{
				text: 'Date::Demande',
				kid:  'K_NODE;DATE',
			},
			{
				text: 'Date::Création',
				kid:  'K_NODE;DATE',
			},
			{
				text: 'Status de la requête',
				kid:  'K_NODE;ACCOUNT_REQUEST_STATUS',
			},
			{
				text: 'Rôle',
				kid:  'K_NODE;KROLE',
			},
			{
				text:       'Organisation',
				kid:        'K_NODE;SYS_CLASSE',
				linker_kid: 'K_NODE;KDROITORG',
			},
			{
				text: 'Super Admin',
				kid:  K_NODE_BOOL,
				linker_kid: K_NODE_SUPERADMIN
			},
			{
				text: 'Notifier',
				kid:  K_NODE_BOOL,
				linker_kid: K_NODE_NOTIFY,
			},
			{
				text: 'Changer le mot de passe',
				kid:  K_NODE_BOOL,
				linker_kid: K_NODE_LOGIN_PASSWORD_CHANGE,
			},
			{
				text: 'Entreprise',
				kid:  'K_NODE;ENTREPRISE',
			},
		];

		/** @type {boolean} */
		this.isAdmin = !!User.getProfil().admin;

		/** @type {boolean} */
		this.isListLoading = true;

		/** @type {number} */
		this.itemsPerPage = 50;

		/** @type {any[]} */
		this.list = [];

		/** @type {string} */
		this.searchText = '';

		/** @type {string} */
		this.sortOrder = 'ASC';

		/** @type {string} */
		this.sortReferenceColumn = '';

		/** @type {boolean} */
		this.statsLoading = false;

		/** @type {number} */
		this.totalItems = 0;

		// TODO: find that dynamically
		/**
		 *  @type {Status[]}
		 */
		this.status = [
			{
				name:    'En attente',
				color:   '#f0ad4e',
				kid:     STATUS_WAITING,
				checked: true,
				count:   -1,
				show:    true,
			},
			{
				name:    'Prêt',
				color:   '#42c81f',
				kid:     STATUS_READY,
				checked: true,
				count:   -1,
				show:    true,
			},
			{
				name:    'En demande de création',
				color:   '#54428e',
				kid:     STATUS_TODO,
				checked: false,
				count:   -1,
				show:    true,
			},
			{
				name:    'En cours de création',
				color:   '#31b0d5',
				kid:     'K_NODE;ACC_REQ_STATUS_DOING',
				checked: false,
				count:   -1,
				show:    false,
			},
			{
				name:    'Créé',
				color:   '#5cb85c',
				kid:     'K_NODE;ACC_REQ_STATUS_DONE',
				checked: false,
				count:   -1,
				show:    true,
			},
			{
				name:    'Erreur',
				color:   '#d9534f',
				kid:     'K_NODE;ACC_REQ_STATUS_ERROR',
				checked: false,
				count:   -1,
				show:    true,
			},
		];

		/** @type {string} */
		this.wsStatus = 'offline';

		/** @type {Array<Action>} */
		this.actions = [
			{
				id:        'edit',
				icon:      'fa fa-edit',
				tooltip:   this.$translate.instant('common.modify'),
				condition: line => [
					STATUS_WAITING,
					STATUS_READY,
				].includes(line.status.kid),
				callback:  (line, event) => {
					event.preventDefault();
					event.stopPropagation();
					$location.url(`/users/form/${line.request.kid}`);
				},
			},
			{
				id:        'delete',
				icon:      'fa fa-trash',
				tooltip:   this.$translate.instant('common.delete'),
				condition: line => line.status.kid === STATUS_WAITING || line.status.kid === STATUS_TODO,
				callback:  async (line, event) => {
					event.preventDefault();
					event.stopPropagation();

					await APIV5.instance.objectDelete({ items: line.request.kid }, { id: 'users.delete' });
					this.Notification.success({
						title:   'Succès !',
						message: `La requête ${line.request.name} a été supprimée sans erreur`,
					});
					const elementIndex = this.list.findIndex(
						entry => entry.request.kid === line.request.kid,
					);
					this.list.splice(elementIndex, 1);
				},
			},
			{
				id:        'switch-creation',
				icon:      'fa fa-play',
				tooltip:   'Demander la création',
				condition: line => line.status.kid === STATUS_READY,
				callback:  async (line, event) => {
					event.preventDefault();
					event.stopPropagation();
					await this.markAllSelected([line], STATUS_TODO);
				},
			},
			{
				id:        'switch-waiting',
				icon:      'fa fa-undo',
				tooltip:   'Annuler la demande de création',
				condition: line => line.status.kid === STATUS_TODO,
				callback:  async (line, event) => {
					event.preventDefault();
					event.stopPropagation();
					await this.markAllSelected([line], STATUS_WAITING);
				},
			},
			{
				id:        'open',
				icon:      'fa fa-external-link',
				tooltip:   'Ouvrir le profil',
				condition: line => line.status.kid === STATUS_DONE,
				callback:  (line, event) => {
					event.preventDefault();
					event.stopPropagation();
					this.$location.url(`/users/form/${line.request.kid}`);
				},
			},
		];

		this.$scope.$watch('currentPage', () => this.fetch());

		/** @type {?WebSocket} */
		this.ws = WebsocketService.socket?.getWs() ?? null;

		$rootScope.$on('socket:ready', (event, socket) => {
			this.ws = socket.getWs();
			this.isEnabled = true;
			this.registerSockets();
		});

		// Init
		(async () => this.fetch())();
	}

	async deleteAllSelected() {
		const cells = this.getSelectedCells();
		const kidsToRemove = cells.map(cell => cell.request.kid);
		await APIV5.instance.objectDelete({ items: kidsToRemove }, { id: 'users.delete-all-selected' });

		this.list = angular.copy(
			this.list.filter(element => !kidsToRemove.includes(element.request.kid)),
		);

		this.Notification.success({
			title:   'Succès !',
			message: 'Les éléments ont été supprimés sans erreur',
		});
	}

	deleteRows() {
		return this.deleteAllSelected();
	}

	/**
	 * @param {any} node
	 * @param {string} concat
	 * @returns {string}
	 */
	displayNode(node, concat = ', ') {
		if (Array.isArray(node)) {
			return node.map(n => n.name)
				.join(concat);
		}
		return node.name;
	}

	async exportRows() {
		const result = await APIV5.instance.queryExecExportXLSX({
			// @ts-ignore
			query:  this.makeUserRequestsQuery(),
			export: 'xlsx',
		});

		await this.FileDownloadService.download([{ kid: result.fileid }]);
	}

	async fetch() {
		this.isListLoading = true;
		const query = this.makeUserRequestsQuery();
		const response = await APIV5.instance.queryExec({
			// @ts-ignore
			query,
			packet_index: (this.currentPage - 1) * this.itemsPerPage + 1,
			packet_size:  this.itemsPerPage,
		}, { id: 'users.fetch' });
		const list = [];

		this.totalItems = response.result.total;

		for (const row of response.result.rows) {
			const element = [];
			for (const [index, cell] of row.entries()) {
				element[index] = cell.length === 1 ? cell[0] : cell;
			}
			list.push(element);
		}

		this.list = list.map(line => ({
			checked:          false,
			locked:           false,
			request:          line[0],
			civility:         line[1],
			firstname:        line[2],
			lastname:         line[3],
			email:            line[4],
			login:            line[5],
			createdRequestAt: line[6],
			createdUserAt:    line[7],
			status:           line[8],
			roles:            line[9],
			orgs:             line[10],
			isAdminSuper:     line[11],
			notify:           line[12],
			passwordChange:   line[13],
			entreprise:       line[14],
		}));

		this.$timeout(() => {
			this.isListLoading = false;
		});
	}

	/**
	 * @param {string} path
	 * @returns {string}
	 */
	getBasename(path) {
		return path.split('/').reverse()[0];
	}

	/**
	 * @param {Event} event
	 * @param {import('@knitiv/api-client-javascript').KNode} statusKid
	 */
	async getRequestsByStatus(event, statusKid) {
		event.stopPropagation();
		const query = angular.copy(minimalQuery);
		query.where = {
			condition: 'OR',
			rules:     [
				{
					condition: 'NONE',
					field:     'K_NODE;ACCOUNT_REQUEST_STATUS',
					having:    null,
					id:        'K_NODE;ACCOUNT_REQUEST_STATUS',
					operator:  'equal_kid',
					path:      [
						{
							kid: K_NODE_ACCOUNT_REQUEST,
						},
						{
							kid:  'K_NODE;ACCOUNT_REQUEST_STATUS',
							flow: 'down',
						},
					],
					type:      'K_NODE;STRING', // required
					value:     [
						{
							kid: statusKid,
						},
					],
				},
			],
		};
		const response = await APIV5.instance.queryExec({
			// @ts-ignore
			query,
			packet_index: 1,
			packet_size:  1,
		});
		const status = this.status.find(s => s.kid === statusKid);
		if (status) {
			status.count = response.result.total;
		}
	}

	getSelectedCells() {
		return this.list.filter(line => line.checked);
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} kid
	 * @returns {any}
	 */
	getStatusFromId(kid) {
		return this.status.find(st => st.kid === kid);
	}

	/**
	 * @param {File[]} files
	 */
	async import(files) {
		if (files.length === 0) {
			throw new Error('Aucun fichier');
		}
		const file = await files[0].arrayBuffer();
		const result = await APIV5.instance.accountRequestImport({
			request: {
				emailNotify: this.emailNotify,
			},
			file,
		});

		// @ts-ignore
		if (result['error']) {
			// @ts-ignore
			const { error } = result;
			console.error(error);
			this.Notification.error({
				title:   error.errno,
				message: error.errno_desc,
			});
		}
		else {
			this.Notification.success({
				title:   this.$translate.instant('object.successfully-created-title'),
				message: this.$translate.instant('object.successfully-created-message'),
			});
			await this.fetch();
		}
	}

	// eslint-disable-next-line class-methods-use-this
	importFile() {
		$('#input-file-hidden').find('input[type="file"]').trigger('click');
	}

	/**
	 *
	 * @param {import('@knitiv/api-client-javascript').KNode} kid
	 * @returns {any}
	 */
	itemStatusStyle(kid) {
		return {
			'background-color': this.getStatusFromId(kid).color,
			border:             `1px solid ${this.getStatusFromId(kid).color}`,
		};
	}

	/**
	 * @param {string} field
	 * @param {string} sortorder
	 * @returns {any}
	 */
	makeSelect(field, sortorder) {
		/** @type {any} */
		const select = [
			{
				kid:  K_NODE_ACCOUNT_REQUEST,
				node: 'REPRE',
				op:   'detail',
			},
			{
				kid:  'K_NODE;CIVILITY',
				node: 'REPRE',
				op:   'detail',
				path: [
					{
						kid:  K_NODE_ACCOUNT_REQUEST,
						flow: null,
					},
					{
						kid:  'K_NODE;CIVILITY',
						flow: 'down',
					},
				],
			},
			{
				kid:  'K_NODE;FIRSTNAME',
				node: 'REPRE',
				op:   'detail',
				path: [
					{
						kid:  K_NODE_ACCOUNT_REQUEST,
						flow: null,
					},
					{
						kid:  'K_NODE;FIRSTNAME',
						flow: 'down',
					},
				],
			},
			{
				kid:  'K_NODE;LASTNAME',
				node: 'REPRE',
				op:   'detail',
				path: [
					{
						kid:  K_NODE_ACCOUNT_REQUEST,
						flow: null,
					},
					{
						kid:  'K_NODE;LASTNAME',
						flow: 'down',
					},
				],
			},
			{
				kid:  'K_NODE;EMAIL',
				node: 'REPRE',
				op:   'detail',
				path: [
					{
						kid:  K_NODE_ACCOUNT_REQUEST,
						flow: null,
					},
					{
						kid:  'K_NODE;EMAIL',
						flow: 'down',
					},
				],
			},
			{
				kid:  'K_NODE;USERNAME',
				node: 'REPRE',
				op:   'detail',
				path: [
					{
						kid:  K_NODE_ACCOUNT_REQUEST,
						flow: null,
					},
					{
						kid:  'K_NODE;USERNAME',
						flow: 'down',
					},
				],
			},
			{
				kid:         'K_NODE;DATE',
				linker_kid:  K_NODE_DATE_DEMANDE,
				node:        'REPRE',
				op:          'detail',
				path:        [
					{
						kid:  K_NODE_ACCOUNT_REQUEST,
						flow: null,
					},
					{
						kid:         'K_NODE;DATE',
						flow:        'down',
						linker_kid:  K_NODE_DATE_DEMANDE,
					},
				],
			},
			{
				kid:         'K_NODE;DATE',
				linker_kid:  'K_NODE;CREATION',
				node:        'REPRE',
				op:          'detail',
				path:        [
					{
						kid:  K_NODE_ACCOUNT_REQUEST,
						flow: null,
					},
					{
						kid:         'K_NODE;DATE',
						flow:        'down',
						linker_kid:  'K_NODE;CREATION',
					},
				],
			},
			{
				kid:  'K_NODE;ACCOUNT_REQUEST_STATUS',
				node: 'REPRE',
				op:   'detail',
				path: [
					{
						kid:  K_NODE_ACCOUNT_REQUEST,
						flow: null,
					},
					{
						kid:  'K_NODE;ACCOUNT_REQUEST_STATUS',
						flow: 'down',
					},
				],
			},
			{
				kid:  'K_NODE;KROLE',
				node: 'REPRE',
				op:   'detail',
				path: [
					{
						kid:  K_NODE_ACCOUNT_REQUEST,
						flow: null,
					},
					{
						kid:  'K_NODE;KROLE',
						flow: 'down',
					},
				],
			},
			{
				kid:  'K_NODE;ANYTHING',
				node: 'REPRE',
				op:   'detail',
				path: [
					{
						kid:  K_NODE_ACCOUNT_REQUEST,
						flow: null,
					},
					{
						kid:        'K_NODE;ANYTHING',
						linker_kid: 'K_NODE;KDROITORG',
						flow:       'down',
					},
				],
			},
			{
				kid:  K_NODE_BOOL,
				linker_kid: K_NODE_SUPERADMIN,
				node: 'REPRE',
				op:   'detail',
				path: [
					{
						kid:  K_NODE_ACCOUNT_REQUEST,
						flow: null,
					},
					{
						kid:  K_NODE_BOOL,
						linker_kid: K_NODE_SUPERADMIN,
						flow: 'down',
					},
				],
			},
			{
				kid:         K_NODE_BOOL,
				linker_kid:  K_NODE_NOTIFY,
				node:        'REPRE',
				op:          'detail',
				path:        [
					{
						kid:  K_NODE_ACCOUNT_REQUEST,
						flow: null,
					},
					{
						kid:         K_NODE_BOOL,
						linker_kid:  K_NODE_NOTIFY,
						flow:        'down',
					},
				],
			},
			{
				kid:         K_NODE_BOOL,
				linker_kid:  K_NODE_LOGIN_PASSWORD_CHANGE,
				node:        'REPRE',
				op:          'detail',
				path:        [
					{
						kid:  K_NODE_ACCOUNT_REQUEST,
						flow: null,
					},
					{
						kid:         K_NODE_BOOL,
						linker_kid:  K_NODE_LOGIN_PASSWORD_CHANGE,
						flow:        'down',
					},
				],
			},
			{
				kid:  'K_NODE;ENTREPRISE',
				node: 'REPRE',
				op:   'detail',
				path: [
					{
						kid: K_NODE_ACCOUNT_REQUEST,
					},
					{
						kid:  'K_NODE;ENTREPRISE',
						flow: 'down',
					},
				],
			},
		];
		if (field) {
			const index = select.findIndex((/** @type {any} */ entry) => entry.kid === field);
			if (index > 0) {
				select[index].sort = sortorder;
			}
		}
		return select;
	}

	makeUserRequestsQuery() {
		const field = this.sortReferenceColumn;
		const order = this.sortOrder;
		return {
			select: this.makeSelect(field, order),
			from:   [defaultFrom],
			where:  {
				condition: 'AND',
				rules:     [
					{
						condition: 'OR',
						rules: ['K_NODE;FIRSTNAME', 'K_NODE;EMAIL', 'K_NODE;LASTNAME', 'K_NODE;USERNAME'].map(kid => ({
							condition: 'NONE',
							field: kid,
							having: null,
							id: kid,
							operator: 'contains',
							path: [
								{
									kid:        K_NODE_ACCOUNT_REQUEST,
									linker_kid: '0',
								},
								{
									kid,
									flow:       'down',
									linker_kid: '0',
								},
							],
							type:       'K_NODE;STRING',
							value:      this.searchText,
							linker_kid: '0',
						})),
					},
					{
						condition: 'AND',
						rules:     [
							{
								condition: 'NONE',
								field:     'K_NODE;ACCOUNT_REQUEST_STATUS',
								having:    null,
								id:        'K_NODE;ACCOUNT_REQUEST_STATUS',
								operator:  'in',
								path:      [
									{
										kid: K_NODE_ACCOUNT_REQUEST,
									},
									{
										kid:  'K_NODE;ACCOUNT_REQUEST_STATUS',
										flow: 'down',
									},
								],
								type:      'K_NODE;STRING', // required
								value:     this.status.filter(status => status.checked).map(status => ({
									kid: status.kid,
								})),
							},
						],
					},
				],
			},
		};
	}

	/**
	 * @param {any[]} cells
	 * @param {import('@knitiv/api-client-javascript').KNode} newStatusKid
	 */
	async markAllSelected(cells, newStatusKid) {
		const cellsToChange = cells.map(cell => ({
			kid:    cell.request.kid,
			status: cell.status.kid,
		}));

		const items = [];

		for (const cell of cellsToChange) {
			const item = {
				target_objnum: cell.kid,
				OBJECT_LIST:   {
					[cell.kid]: {
						isa:       K_NODE_ACCOUNT_REQUEST,
						LINK_LIST: {
							[COMPOSED_OF]: [
								{
									action:    'DEL',
									objnum2:   cell.status,
									class_kid: ACCOUNT_REQUEST_STATUS_KID,
								},
								{
									action:    'ADD',
									objnum2:   newStatusKid,
									class_kid: ACCOUNT_REQUEST_STATUS_KID,
								},
							],
						},
					},
				},
			};
			items.push(item);
		}

		await APIV5.instance.objectModify({ items }, { id: 'users.mark-all-selected' });
		await this.updateRowStatus();

		this.Notification.success({
			title:   this.$translate.instant('object.successfully-updated-title'),
			message: this.$translate.instant('object.successfully-updated-message'),
		});
	}

	markAsAsking() {
		const toReadyCells = this.getSelectedCells();
		return this.markAllSelected(toReadyCells, STATUS_TODO);
	}

	markAsWaiting() {
		const toWaitingCells = this.getSelectedCells();
		return this.markAllSelected(toWaitingCells, STATUS_WAITING);
	}

	registerSockets() {
		// Socket

		const onOpen = async () => {
			this.$timeout(() => {
				this.wsStatus = 'online';
			});
		};

		if (this.ws?.readyState === 1) {
			onOpen();
		}

		this.ws?.addEventListener('open', async () => {
			onOpen();
		});

		this.ws?.addEventListener('close', () => {
			this.$timeout(() => {
				this.wsStatus = 'offline';
			});
		});

		this.ws?.addEventListener('error', error => {
			console.error(error);
		});
	}

	sendCreation() {
		this.ws?.send(JSON.stringify({
			version: '1.0.0',
			action:  'BROADCAST',
			path:    `${this.$rootScope.context?.env.kid}/ORDO`,
			filters: [],
			payload: {
				command: 'launch',
				options: {
					ref_applicant:   this.$rootScope.context?.profil.kid,
					dsnasso_kid:     'K_NODE;DSNA_KSYSTEM',
					db_applicant:    this.$rootScope.context?.dsnasso.kid,
					scenario_kid:    'K_NODE;KGDT_CREATEUSERS',
					scenario_params: {},
				},
			},
		}));
	}

	async statsLogin() {
		this.statsLoading = true;

		const result = await APIV5.instance.stats.login('001', { output: 'xlsx' });

		this.$timeout(() => {
			this.statsLoading = false;
		});

		if (result) {
			const disposition = result.headers('Content-Disposition');
			if (disposition && disposition.includes('attachment')) {
				// eslint-disable-next-line no-useless-backreference
				const matches = /filename[^\n;]*=(UTF-\d["']*)?((["']).*?\.$\2|[^\n;]*)?/.exec(disposition);
				if (matches !== null && matches[2]) {
					const filename = decodeURIComponent(matches[2].replaceAll(/('|\\"|")/g, ''));
					Utils.download(result.buffer, result.headers('Content-Type'), filename);
				}
			}
		}
	}

	/**
	 * @param {any} status
	 * @returns {any}
	 */
	statusStyle(status) {
		const style = {};

		style['background-color'] = status.checked ? `${status.color}` : '#ddd';
		style.border = `1px solid ${status.color}`;
		if (!status.checked) {
			style.color = 'black';
		}
		return style;
	}

	/**
	 * @param {any} line
	 */
	toggleSelected(line) {
		const requestKid = line.request.kid;

		const request = this.list.find(row => row.request.kid === requestKid);
		request.checked = !request.checked;
	}

	updateRowStatus() {
		return this.fetch();
	}
}
